import React, { useId, useMemo } from "react"
import SVGInline, { type SVGInlineProps } from "react-svg-inline"

interface SignSVGInlineProps extends SVGInlineProps {
  svg: string
}

const randomizeIDs = (svg: string, id?: string) => {
  const randomHex = id || (Math.random() * 0xfffff * 1000000).toString(16).slice(0, 6)
  return svg.replace(/random-id/gi, randomHex)
}

const SignSVGInline: React.FC<SignSVGInlineProps> = ({ svg, ...props }) => {
  const id = useId()
  const previewSvg = useMemo(() => randomizeIDs(svg, id), [svg, id])

  return <SVGInline svg={previewSvg} {...props} />
}

export default SignSVGInline
